import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'M&Aの相談は無料ですか？',
      answer: 'はい、初回相談は完全無料です。秘密厳守でお話を伺いますので、お気軽にご相談ください。'
    },
    {
      question: '費用はいつ発生しますか？',
      answer: '完全成功報酬制のため、成約時のみ費用が発生します。着手金や月額費用は一切かかりません。'
    },
    {
      question: 'どのくらいの期間で成約できますか？',
      answer: '案件により異なりますが、平均的には3〜6ヶ月程度です。お急ぎの場合は最短での対応も可能です。'
    },
    {
      question: '小規模な会社でも対応してもらえますか？',
      answer: 'はい、規模に関わらず対応いたします。中小企業のM&Aを専門としておりますので、安心してご相談ください。'
    },
    {
      question: '情報が漏れる心配はありませんか？',
      answer: '厳格な情報管理体制を整えており、秘密保持契約を締結した上で進めますので、情報漏洩の心配はございません。'
    },
    {
      question: '従業員の雇用は守られますか？',
      answer: '買い手企業との交渉において、従業員の雇用継続を重要な条件として進めることが可能です。'
    },
    {
      question: '売却後も経営に関わることはできますか？',
      answer: 'はい、条件次第で可能です。一定期間の経営参画や顧問契約など、柔軟に対応いたします。'
    },
    {
      question: '地方の企業でも対応可能ですか？',
      answer: 'はい、全国対応しております。オンライン面談も活用し、地域を問わずサポートいたします。'
    }
  ];

  return (
    <section className="py-32 bg-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5">
        <div className="absolute top-20 left-1/4 w-96 h-96 bg-teal-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-1/4 w-96 h-96 bg-cyan-500 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-20">
          <span className="text-teal-600 font-bold text-sm tracking-widest uppercase mb-4 block">
            FAQ
          </span>
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">
            よくあるご質問
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            お客様からよくいただくご質問にお答えします
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`group relative bg-gradient-to-br from-slate-50 to-white rounded-2xl overflow-hidden border-2 transition-all duration-500 ${
                openIndex === index 
                  ? 'border-teal-500 shadow-xl shadow-teal-500/10' 
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              {/* Gradient Accent */}
              {openIndex === index && (
                <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-teal-500 to-cyan-500"></div>
              )}

              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-white/50 transition-colors cursor-pointer"
              >
                <div className="flex items-start flex-1 pr-4">
                  <div className={`w-8 h-8 rounded-xl flex items-center justify-center mr-4 flex-shrink-0 transition-all duration-500 ${
                    openIndex === index 
                      ? 'bg-gradient-to-br from-teal-500 to-cyan-500' 
                      : 'bg-gray-200 group-hover:bg-gray-300'
                  }`}>
                    <span className={`font-black text-sm ${
                      openIndex === index ? 'text-white' : 'text-gray-600'
                    }`}>
                      Q
                    </span>
                  </div>
                  <span className="font-bold text-gray-900 text-base leading-relaxed">
                    {faq.question}
                  </span>
                </div>
                
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 transition-all duration-500 ${
                  openIndex === index 
                    ? 'bg-gradient-to-br from-teal-500 to-cyan-500 rotate-180' 
                    : 'bg-gray-200 group-hover:bg-gray-300'
                }`}>
                  <i className={`ri-arrow-down-s-line text-xl ${
                    openIndex === index ? 'text-white' : 'text-gray-600'
                  }`}></i>
                </div>
              </button>

              <div className={`overflow-hidden transition-all duration-500 ${
                openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
              }`}>
                <div className="px-8 pb-6 pl-20">
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-gradient-to-br from-cyan-500 to-teal-500 rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
                      <span className="font-black text-sm text-white">A</span>
                    </div>
                    <p className="text-sm text-gray-600 leading-relaxed pt-1">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
